// Central content + assets for Rainey's Soul Food

export const RESTAURANT = {
  name: "Rainey's Soul Food",
  legalName: "Rainey's Soul Food LLC",
  tagline: "Authentic Soul Food",
  cateringTagline: "Bringing Soulful Flavors Wherever You Celebrate",
  phone: "(757) 807-2407",
  phoneHref: "tel:+17578072407",
  cateringPhone: "(631) 494-9433",
  cateringPhoneHref: "tel:+16314949433",
  address: {
    line1: "1771 N King Street",
    line2: "Hampton, VA 23669",
  },
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=1771+N+King+Street+Hampton+VA+23669",
  mapEmbedUrl:
    "https://www.google.com/maps?q=1771+N+King+Street,+Hampton,+VA+23669&output=embed",
  googleListingUrl:
    "https://www.google.com/maps/search/Rainey%27s+Soul+Food+1771+N+King+Street+Hampton+VA",
};

// Catering / private-events copy provided by the owner
export const CATERING_INFO = {
  paragraphs: [
    "Based in Virginia, Rainey's Soul Food LLC provides exceptional catering services throughout Virginia and Houston, Texas, as well as the surrounding states. We bring our signature soul food with a Caribbean flair directly to you, creating memorable dining experiences filled with flavor, warmth, and Southern hospitality.",
    "From backyard gatherings and family reunions to private parties, corporate events, and special celebrations, our team travels to make your event unforgettable.",
    "At Rainey's Soul Food, every dish is prepared with love, passion, and the tradition of bringing people together through great food.",
  ],
  events: [
    "Backyard Gatherings",
    "Family Reunions",
    "Private Parties",
    "Corporate Events",
    "Special Celebrations",
    "Intimate / Couple Settings",
  ],
  note: "Please note — we do not cater weddings.",
  cta: "Let us bring the taste of Rainey's Soul Food to your next celebration.",
};

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_raineys-hampton/artifacts/bdqbnjwt_348s-2.jpg",
  owner:
    "https://customer-assets.emergentagent.com/job_raineys-hampton/artifacts/v9b1uc7c_chef-rainey-800x800-1.png",
  coowner:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_raineys-hampton/artifacts/2pdn2fg7_ChatGPT%20Image%20Jul%2029%2C%202026%20at%2008_34_36%20PM.png",
};

export const DISHES = [
  {
    name: "Oxtails",
    desc: "Slow-braised until fork-tender in a rich, savory gravy.",
    img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_raineys-hampton/artifacts/yu3oom98_IMG_6334.jpeg",
  },
  {
    name: "Curry Chicken",
    desc: "Island-spiced curry simmered low and slow with rice & cabbage.",
    img: "https://customer-assets.emergentagent.com/job_raineys-hampton/artifacts/kvy10ml8_348s-3.jpg",
  },
  {
    name: "Jerk Chicken",
    desc: "Charred, smoky, and packed with authentic island heat.",
    img: "https://static.prod-images.emergentagent.com/jobs/23916d56-904b-42ae-bce4-1b015c602314/images/8aa82785e5dc505f8b447998605ff7b4954bc74737d51943f333faf3d39fc291.jpeg",
  },
  {
    name: "Crispy Fried Chicken Wings",
    desc: "Golden, crispy wings with creamy mac & cheese and candied yams.",
    img: "https://static.prod-images.emergentagent.com/jobs/23916d56-904b-42ae-bce4-1b015c602314/images/0209ace8d411dfbed1f62e2fb20870781ef8f9eea28c2e6c4e82c8d536b0446e.jpeg",
  },
  {
    name: "Fried Red Snapper",
    desc: "Whole snapper fried crisp, smothered in sautéed peppers, onions & carrots.",
    img: "https://static.prod-images.emergentagent.com/jobs/23916d56-904b-42ae-bce4-1b015c602314/images/c5568f2139ddb7820e5e60874a2452aa100ba285528a4e9a8a83dfd93d5b9458.jpeg",
  },
  {
    name: "Smothered Turkey Wings",
    desc: "Slow-baked and glazed until rich, sticky, and tender.",
    img: "https://static.prod-images.emergentagent.com/jobs/23916d56-904b-42ae-bce4-1b015c602314/images/68d88948d7681d84bf78697960d082451295c277954159ada95ab03455769858.jpeg",
  },
];

export const LUNCH_SPECIAL = {
  time: "12:00 PM – 2:00 PM",
  days: "Tuesday – Friday",
  note: "Comes with 2 sides",
  items: [
    { name: "Curry Goat", price: "$18.00" },
    { name: "Veggie Plate (3 Sides)", price: "$13.50" },
    { name: "3 Whole Wings w/Fries", price: "$13.50" },
    { name: "Whiting w/Fries (1)", price: "$14.00" },
    { name: "Brown Stew Chicken", price: "$15.00" },
    { name: "Curry Chicken", price: "$15.00" },
    { name: "Jerk Chicken", price: "$15.00" },
  ],
};

export const MENU = [
  {
    category: "Dinner Entrees",
    note: "Comes with 2 sides",
    items: [
      { name: "Oxtail", price: "$26.00" },
      { name: "Curry Goat", price: "$24.00" },
      { name: "Turkey Wings (1)", price: "$18.00" },
      { name: "Turkey Wings (2)", price: "$24.00" },
      { name: "Jerk Chicken", price: "$18.00" },
      { name: "Curry Chicken", price: "$18.00" },
      { name: "Brown Stew Chicken", price: "$18.00" },
      { name: "Whole Wings (5)", price: "$17.25" },
      { name: "Veggie Plate (3 Sides)", price: "$14.50" },
    ],
  },
  {
    category: "Seafood Plates",
    note: "Fresh from the fryer",
    items: [
      { name: "Red Snapper", price: "Market Price" },
      { name: "Jumbo Shrimp (10) w/Fries", price: "$19.00" },
      { name: "Jumbo Shrimp Meal (10)", price: "$24.00" },
      { name: "Curry Coconut Shrimp", price: "$24.00" },
      { name: "Whiting (2) w/Fries", price: "$16.00" },
      { name: "Whiting Meal", price: "$18.50" },
    ],
  },
  {
    category: "A La Carte",
    note: "Just the good stuff",
    items: [
      { name: "Jumbo Shrimp (8)", price: "$15.00" },
      { name: "Curry Goat", price: "$14.25" },
      { name: "J. Chicken", price: "$14.25" },
      { name: "Turkey Wings (1 Piece)", price: "$11.00" },
      { name: "Brown Stew Chicken", price: "$14.00" },
      { name: "Whole Wings (5)", price: "$10.00" },
    ],
  },
];

// Sides with Small / Large pricing
export const SIDES = [
  { name: "White Rice", small: "$4", large: "$6" },
  { name: "Rice & Peas", small: "$5", large: "$9" },
  { name: "Yams", small: "$5", large: "$9" },
  { name: "Collards", small: "$5", large: "$9" },
  { name: "Mac & Cheese", small: "$5", large: "$9" },
  { name: "Potato Salad", small: "$5", large: "$9" },
  { name: "String Beans", small: "$5", large: "$9" },
  { name: "Cabbage", small: "$5", large: "$9" },
];

// Beverages
export const DRINKS = [
  { name: "Coca Cola", price: "$2.50" },
  { name: "Pepsi", price: "$2.75" },
  { name: "Sprite", price: "$2.50" },
  { name: "Ginger Ale", price: "$2.50" },
  { name: "Ting", price: "$3.00" },
  { name: "Kola Champagne", price: "$3.00" },
  { name: "Pineapple", price: "$3.00" },
  { name: "Bottled Water", price: "$1.25" },
  { name: "Sweet Tea", price: "$3.50" },
  { name: "Specialty Drinks", price: "$5.00" },
];

// Chef-plated dishes for the Catering & Private Events section
export const CATERING = [
  {
    name: "Grilled Chili-Lime Chicken",
    desc: "Charred chicken thighs with cilantro-lime crema, jalapeño & lime.",
    img: "https://customer-assets.emergentagent.com/job_raineys-hampton/artifacts/8y4omcs4_Screenshot%202026-07-14%20at%2017.08.44.png",
  },
  {
    name: "Honey BBQ Ribs & Fried Rice",
    desc: "Fall-apart glazed ribs served alongside vegetable fried rice.",
    img: "https://static.prod-images.emergentagent.com/jobs/23916d56-904b-42ae-bce4-1b015c602314/images/1f9f282158678442fa944254d3ad6bcdd5dd2534493bc7ff30be2b3d4f778fba.png",
  },
  {
    name: "Stuffed Pork Chop",
    desc: "Bone-in chop over savory dressing with roasted sweet potato & broccoli.",
    img: "https://static.prod-images.emergentagent.com/jobs/23916d56-904b-42ae-bce4-1b015c602314/images/5de69183bf52696fbe599a57cb73be880b5e157a7efba1772789b2ce96fd78d9.png",
  },
  {
    name: "Orange-Glazed Fish",
    desc: "Seared fish with caramelized orange over jasmine rice & rich glaze.",
    img: "https://static.prod-images.emergentagent.com/jobs/23916d56-904b-42ae-bce4-1b015c602314/images/d928a69df673f9204d4ee058c71c456f7b1e66347c83f35b7bdaba8a1785c139.png",
  },
  {
    name: "Southern Shepherd's Pie",
    desc: "Seasoned ground beef under a golden baked mashed-potato crust.",
    img: "https://static.prod-images.emergentagent.com/jobs/23916d56-904b-42ae-bce4-1b015c602314/images/23e5a399f82d7633d1a41490ea6156c000ccba5d12a379ad2038e3b0b3aa1bb7.png",
  },
];

// day: 0 = Sunday ... 6 = Saturday
export const HOURS = [
  { label: "Sunday", day: 0, open: null },
  { label: "Monday", day: 1, open: null },
  { label: "Tuesday", day: 2, open: "12:00 PM", close: "7:00 PM" },
  { label: "Wednesday", day: 3, open: "12:00 PM", close: "7:00 PM" },
  { label: "Thursday", day: 4, open: "12:00 PM", close: "7:00 PM" },
  { label: "Friday", day: 5, open: "12:00 PM", close: "7:00 PM" },
  { label: "Saturday", day: 6, open: "12:00 PM", close: "7:00 PM" },
];

// Real Google reviews will be added here from the owner's Google Business Profile.
// Do not fabricate content. Empty by default -> UI shows a graceful prompt.
export const REVIEWS_DATA = {
  overallRating: 4.5,
  totalReviews: 146,
  reviews: [
    {
      author: "Luke Mitchell",
      initials: "LM",
      rating: 5,
      date: "2 months ago",
      text: "Cannot recommend this place enough!!! 10/10. On my way back from a dentist appointment today I decided I would try a place I haven't tried and it was a great decision. Service was great, cook came out to verify that the food looked good before giving it to me. Place was clean, food came out quick and the food was absolutely immaculate — and I'm not joking when I say it was the best jerk chicken I've ever had: juicy, spicy and bursting with flavor. Please go check this place out if you have not. I'll definitely be back!",
    },
    {
      author: "Michele Newby",
      initials: "MN",
      rating: 5,
      date: "3 months ago",
      text: "I do not know where to start… the food was absolutely delicious! I ordered the turkey wings, collard greens and mac & cheese! I also ordered the oxtails, peas and rice and curry goat for my husband. Everything we ordered was great! My favorite by far was the collard greens, seasoned to perfection and tender! A whole lot of love went into this food. The owner Ms Rainey even came over to greet us! If you are looking for some good home cooked soul food check them out! And try the pineapple ginger drink!! Loved it!! You will not be disappointed.",
    },
    {
      author: "Maleka Gillison",
      initials: "MG",
      rating: 5,
      date: "8 months ago",
      text: "I ordered takeout from this soul food spot, and everything was amazing. I had the fried wings, which were perfectly crispy and seasoned so well. The mac and cheese was really good — the consistency and texture were spot on! The yams were perfect to me. My husband had the curry goat with mac, yams, and greens, and he really enjoyed the greens. The facility was clean, vibrant, and I appreciated seeing scripture — it made me feel safe and welcomed. I'll definitely be returning!",
    },
    {
      author: "Adelsie Najacque",
      initials: "AN",
      rating: 5,
      date: "9 months ago",
      text: "Rainey's Soul Food is delicious — definitely one of my new favorite spots in Hampton! Everyone in the restaurant is so nice, and the service is quick with little to no wait time. The curry chicken was tender and full of flavor, and the yams were to die for — perfectly balanced and absolutely amazing. The mac and cheese was just right, cheesy but not over the top, and tasted just like home. Overall, the food was great!",
    },
  ],
};
